var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h3", { staticClass: "grey-color mb-3 main_text font-weight-bold" }, [
        _vm._v("Коммерческие извещения"),
      ]),
      _c(
        "b-row",
        { staticClass: "mb-2 cabinet_filter" },
        [
          _c("filter-new-text", {
            attrs: {
              label: "Рег.номер закупки",
              md: "6",
              placeholder: "Введите рег.номер закупки",
            },
            model: {
              value: _vm.filter.reg_number,
              callback: function ($$v) {
                _vm.$set(_vm.filter, "reg_number", $$v)
              },
              expression: "filter.reg_number",
            },
          }),
          _c("filter-new-multiple-select", {
            attrs: {
              options: _vm.filterStatuses,
              label: "Статус закупки",
              "label-class": "grey-color",
              "label-field": "title",
              lg: "6",
              md: "6",
              placeholder: "Выберите статус",
            },
            model: {
              value: _vm.filter.status,
              callback: function ($$v) {
                _vm.$set(_vm.filter, "status", $$v)
              },
              expression: "filter.status",
            },
          }),
          _c("filter-new-multiple-select", {
            attrs: {
              options: _vm.$globalDictionaries.deliverableGroups,
              label: "Предмет закупки",
              "label-class": "grey-color",
              "label-field": "title",
              lg: "6",
              md: "6",
              placeholder: "Выберите предметы закупки",
            },
            model: {
              value: _vm.filter.deliverable_groups,
              callback: function ($$v) {
                _vm.$set(_vm.filter, "deliverable_groups", $$v)
              },
              expression: "filter.deliverable_groups",
            },
          }),
          _c(
            "b-col",
            { staticClass: "mb-1 mt-auto", attrs: { lg: "3", md: "3" } },
            [
              _c(
                "b-btn",
                {
                  staticClass: "text-uppercase w-100",
                  staticStyle: { height: "32px", "line-height": "15px" },
                  attrs: { variant: "custom-green" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.getPurchases(true)
                    },
                  },
                },
                [_vm._v("НАЙТИ")]
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "mb-1 mt-auto", attrs: { lg: "3", md: "3" } },
            [
              _c(
                "b-btn",
                {
                  staticClass: "text-uppercase w-100",
                  staticStyle: { height: "32px", "line-height": "15px" },
                  attrs: { variant: "custom-outline-secondary" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.clearFilter.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("СБРОС")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.purchases && _vm.meta.total > 0 && _vm.meta.last_page > 1
        ? _c("b-pagination", {
            staticClass: "my-1",
            attrs: {
              "per-page": _vm.meta.per_page,
              "total-rows": _vm.meta.total,
              align: "center",
            },
            model: {
              value: _vm.meta.current_page,
              callback: function ($$v) {
                _vm.$set(_vm.meta, "current_page", $$v)
              },
              expression: "meta.current_page",
            },
          })
        : _vm._e(),
      _vm._l(_vm.purchases, function (purchase) {
        return _c(
          "div",
          { key: purchase.id },
          [
            _c("cabinet-commercial-notice-card", {
              attrs: { purchase: purchase },
              on: {
                refresh: function ($event) {
                  return _vm.getPurchases()
                },
              },
            }),
          ],
          1
        )
      }),
      !_vm.purchases.length && !_vm.loading ? _c("empty-request") : _vm._e(),
      _vm.purchases && _vm.meta.total > 0 && _vm.meta.last_page > 1
        ? _c("b-pagination", {
            staticClass: "my-1",
            attrs: {
              "per-page": _vm.meta.per_page,
              "total-rows": _vm.meta.total,
              align: "center",
            },
            on: {
              input: function ($event) {
                return _vm.getPurchases()
              },
            },
            model: {
              value: _vm.meta.current_page,
              callback: function ($$v) {
                _vm.$set(_vm.meta, "current_page", $$v)
              },
              expression: "meta.current_page",
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }